import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { createPick } from '../services/pickService';
import { useActivePick } from '../hooks/useActivePick';
import { formatGameTime } from '../utils/formatters';
import { ROUTES } from '../utils/constants';
import toast from 'react-hot-toast';
import './PickFlowPage.css';

export default function PickFlowPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { game, side } = location.state || {};
  const { activePick } = useActivePick();
  const [loading, setLoading] = useState(false);

  if (!game || !side) {
    navigate(ROUTES.GAMES, { replace: true });
    return null;
  }

  const isDraw = side === 'draw';
  const pickedTeam = isDraw ? { name: 'Draw' } : side === 'home' ? game.homeTeam : game.awayTeam;

  const isReplacingPick = activePick && activePick.status === 'pending';

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await createPick(game.gameId, side);
      toast.success(`Picked ${pickedTeam.name}!`);
      navigate(ROUTES.HOME, { replace: true });
    } catch (err) {
      console.error('Error creating pick:', err);
      const message = err.message || 'Failed to create pick. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pick-flow-page">
      <div className="pick-flow-card">
        <h1>Confirm Your Pick</h1>

        <div className="pick-flow-game">
          <span className="pick-flow-time">{formatGameTime(game.startTime)}</span>
          <span className="pick-flow-league">{game.league}</span>
        </div>

        <div className="pick-flow-matchup">
          <div className={`pick-flow-team ${side === 'away' ? 'picked' : isDraw ? '' : 'opponent'}`}>
            {game.awayTeam.logo && (
              <img src={game.awayTeam.logo} alt={game.awayTeam.abbreviation} className="pick-team-logo" />
            )}
            <span className="pick-team-name">{game.awayTeam.name}</span>
          </div>

          <span className="pick-flow-at">{isDraw ? 'vs' : '@'}</span>

          <div className={`pick-flow-team ${side === 'home' ? 'picked' : isDraw ? '' : 'opponent'}`}>
            {game.homeTeam.logo && (
              <img src={game.homeTeam.logo} alt={game.homeTeam.abbreviation} className="pick-team-logo" />
            )}
            <span className="pick-team-name">{game.homeTeam.name}</span>
          </div>
        </div>

        <div className="pick-flow-selection">
          {isDraw
            ? <>Your pick: <strong>Draw</strong></>
            : <>Your pick: <strong>{pickedTeam.name}</strong> to win</>
          }
        </div>

        {isReplacingPick && (
          <div className="pick-flow-warning">
            This will replace your current pick ({activePick.pickTeamName})
          </div>
        )}

        <div className="pick-flow-actions">
          <button
            className="btn btn-primary btn-full"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Confirm Pick'}
          </button>
          <button
            className="btn btn-secondary btn-full"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
